import Backstage from "nexia_mobile/backstage";
import Schema from "nexia_mobile/models/schema";

export default class UserCodeSchema extends Schema {
  monitorStatus() {
    if (this.get("statusUrl") == null) {
      return;
    }
    new Backstage(this.get("statusUrl"), {
      pollingUpdate: (data) => {
        this.set("message", data.message);
        this.trigger("userCodeSave:update", this);
        if (data.progress != null) {
          this.set(
            "progress",
            data.progress.completed_steps / data.progress.total_steps
          );
          this.trigger("progressUpdate", this);
        }
      },
      success: () => {
        this.trigger("userCodeSave:success", this);
      },
      error: (errors) => {
        this.trigger("userCodeSave:failure", this, errors);
      },
    }).startPolling();
  }
}



// WEBPACK FOOTER //
// ./src/models/user_code_schema.js